import React from 'react';
import { Container } from 'react-bootstrap';
import { CheckInProvider } from './context/CheckInContext';
import Header from './components/checkin/Header';
import CheckInForm from './components/checkin/CheckInForm';
import ThankYouOverlay from './components/checkin/ThankYouOverlay';

import './styles/darkTheme.css';

const CheckInApp: React.FC = () => {
  return (
    <CheckInProvider>
      <Container fluid className="vh-100 d-flex flex-column">
        <Header title="Student Checkin" />
        <ThankYouOverlay />
        <CheckInForm />
      </Container>
    </CheckInProvider>
  );
};

export default CheckInApp;